(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["drawer-linked-tools"] && !Shopify.designMode) return;
  try {
    /* Repeated Escape presses must step back through deep panels rather than spend
   the native dialog's close-cancellation allowance. Forward the key to the
   existing Back button, preserving the original animation and focus behavior. */
(() => {
  'use strict';
  const TAG = 'wgp-linked-menu-navigation';
  if (customElements.get(TAG)) return;
  class LinkedMenuNavigation extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.abort) return;
        const drawer = this.closest('[data-menu-dialog]');
        if (!drawer) return;
        this.abort = new AbortController();
        drawer.addEventListener('keydown', event => {
          if (event.key !== 'Escape' || event.defaultPrevented || !drawer.open) return;
          if (drawer.hasAttribute('data-menu-transitioning')) {
            event.preventDefault();
            return;
          }
          const active = [...drawer.querySelectorAll('[data-menu-panel]')].find(panel =>
            panel.dataset.menuPanel === drawer.dataset.activePanel
          ) || drawer.querySelector('[data-menu-panel]:not([hidden])');
          const back = active?.querySelector('[data-menu-back]');
          if (back) { event.preventDefault(); back.click(); }
          // At root, let the dialog and existing close handler act normally.
        }, { signal: this.abort.signal });
      });
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
  }
  customElements.define(TAG, LinkedMenuNavigation);
})();

(() => {
  'use strict';
  const TAG = 'wgp-linked-menu-tools';
  if (customElements.get(TAG)) return;
  class LinkedMenuTools extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected && !this.abort) this.init(); });
    }
    init() {
      this.drawer = this.closest('[data-menu-dialog]');
      if (!this.drawer) return;
      this.abort = new AbortController();
      this.update();
      document.addEventListener('shopify:block:select', event => {
        const id = String(event.detail?.blockId || '');
        const config = [...this.querySelectorAll('[data-linked-config]')].find(node => node.dataset.linkedConfig === id);
        if (!config) return;
        this.hidden = false;
        this.querySelector('details').open = true;
        this.update();
        if (!this.drawer.open) {
          if (window.Portal?.openDialog) window.Portal.openDialog(this.drawer, document.activeElement);
          else this.drawer.showModal?.();
        }
        config.scrollIntoView({ block: 'nearest', behavior: 'instant' });
      }, { signal: this.abort.signal });
    }
    update() {
      const paths = [...this.drawer.querySelectorAll('[data-menu-path-key]')];
      const mounts = [...this.drawer.querySelectorAll('[data-linked-menu-mount]')];
      for (const config of this.querySelectorAll('[data-linked-config]')) {
        const matches = paths.filter(node => node.dataset.menuPathKey === config.dataset.pathKey);
        const attached = mounts.filter(node => node.dataset.linkedMenuMount === config.dataset.linkedConfig);
        let message;
        if (config.dataset.enabled === 'false') message = 'Disabled. The original menu is unchanged.';
        else if (config.dataset.pathKey === '~invalid~' || !config.dataset.pathKey) message = 'Enter a complete parent category path.';
        else if (config.dataset.hasMenu !== 'true') message = 'Select a menu containing at least one item.';
        else if (attached.length) message = 'Connected. This category opens the linked menu.';
        else if (!matches.length) message = 'No matching category found. Check the full path, spelling and any earlier linked menu in this branch.';
        else if (matches.length > 1 || matches.some(node => node.dataset.menuPathAmbiguous === 'true')) message = 'Ambiguous category path. Rename duplicate labels at the same level before linking here.';
        else if (matches.some(node => Number(node.dataset.menuDepth) >= 12)) message = 'This path is at the 12-level limit. Attach the menu higher in the tree.';
        else message = 'Not attached. Another enabled block may already control this path; the first valid mapping wins.';
        config.querySelector('[data-linked-result]').textContent = message;
      }
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
  }
  customElements.define(TAG, LinkedMenuTools);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["media-credit"] && !Shopify.designMode) return;
  try {
    /* Measure only the attribution's clearance. No carousel, timer, link or cart
   handlers are changed. Reads all Hero credits so slide changes cannot jump. */
(() => {
  'use strict';
  const tag = 'wgp-media-credit';
  if (customElements.get(tag)) return;
  class MediaCredit extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected && !this.abort) this.start(); });
    }
    start() {
      this.host = this.closest('[data-wgp-credit-host]');
      if (!this.host) return;
      this.group = this.closest('wgp-hero-slideshow');
      this.abort = new AbortController();
      this.frame = null;
      const schedule = () => this.schedule();
      window.addEventListener('resize', schedule, { signal: this.abort.signal, passive: true });
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(schedule);
        this.observer.observe(this);
      }
      this.schedule();
    }
    schedule() {
      if (!this.abort || this.frame !== null) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.measure(); });
    }
    measure() {
      if (!this.isConnected || !this.abort) return;
      const owner = this.group || this.host;
      const credits = this.group ? [...this.group.querySelectorAll('wgp-media-credit')] : [this];
      const height = Math.max(0, ...credits.map(credit => credit.offsetHeight));
      const clearance = `${Math.ceil(height) + 8}px`;
      if (owner.style.getPropertyValue('--wgp-credit-space') !== clearance) {
        owner.style.setProperty('--wgp-credit-space', clearance);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      if (this.frame !== null) cancelAnimationFrame(this.frame);
      this.frame = null; this.abort = null;
    }
  }
  customElements.define(tag, MediaCredit);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-description"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  if (customElements.get('wgp-product-description')) return;

  const blockTags = new Set([
    'ADDRESS', 'ARTICLE', 'ASIDE', 'BLOCKQUOTE', 'BR', 'CAPTION', 'DD', 'DETAILS',
    'DIV', 'DL', 'DT', 'FIGCAPTION', 'FIGURE', 'FOOTER', 'H1', 'H2', 'H3', 'H4',
    'H5', 'H6', 'HEADER', 'HR', 'LI', 'MAIN', 'NAV', 'OL', 'P', 'PRE', 'SECTION',
    'SUMMARY', 'TABLE', 'TBODY', 'TD', 'TFOOT', 'TH', 'THEAD', 'TR', 'UL'
  ]);
  const skipTags = new Set([
    'SCRIPT', 'STYLE', 'TEMPLATE', 'NOSCRIPT', 'SVG', 'CANVAS', 'IFRAME',
    'VIDEO', 'AUDIO', 'OBJECT', 'BUTTON', 'INPUT', 'SELECT', 'TEXTAREA'
  ]);

  // Paragraphs, list items and table cells are word boundaries even when the
  // source HTML has no whitespace between their closing/opening tags.
  function descriptionWords(root) {
    const parts = [];
    function visit(node) {
      if (node.nodeType === Node.TEXT_NODE) { parts.push(node.nodeValue); return; }
      if (node.nodeType !== Node.ELEMENT_NODE) return;
      if (skipTags.has(node.tagName) || node.hidden || node.getAttribute('aria-hidden') === 'true') return;
      const boundary = blockTags.has(node.tagName);
      if (boundary) parts.push(' ');
      node.childNodes.forEach(visit);
      if (boundary) parts.push(' ');
    }
    // Iterate the children, since root may itself be hidden after a reconnect.
    root.childNodes.forEach(visit);
    const text = parts.join('').replace(/\s+/gu, ' ').trim();
    return text ? text.split(' ') : [];
  }

  class WGPProductDescription extends HTMLElement {
    constructor() {
      super();
      this._onToggle = this.toggle.bind(this);
      this._beforePrint = this.beforePrint.bind(this);
      this._afterPrint = this.afterPrint.bind(this);
      this._onHash = this.revealHash.bind(this);
    }

    connectedCallback() {
      // Wait for child markup when inserted by Shopify's section editor.
      this._frame = requestAnimationFrame(() => this.initialize());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this._frame);
      this._button?.removeEventListener('click', this._onToggle);
      window.removeEventListener('beforeprint', this._beforePrint);
      window.removeEventListener('afterprint', this._afterPrint);
      window.removeEventListener('hashchange', this._onHash);
    }

    initialize() {
      if (!this.isConnected) return;
      this._full = this.querySelector('[data-description-full]');
      this._preview = this.querySelector('[data-description-preview]');
      this._button = this.querySelector('[data-description-toggle]');
      if (!this._full || !this._preview || !this._button) return;
      this._more = this.dataset.moreLabel?.trim() || 'Read more';
      this._less = this.dataset.lessLabel?.trim() || 'Read less';
      this._accordion = this.closest('details.wgp-description-accordion');
      try {
        const parsed = Number.parseInt(this.dataset.wordLimit, 10);
        const limit = Number.isFinite(parsed) ? Math.min(200, Math.max(20, parsed)) : 60;
        const words = descriptionWords(this._full);
        this._canCollapse = this.dataset.collapseEnabled !== 'false' && words.length > limit;
        if (this._canCollapse) {
          // textContent, never innerHTML: markup-like merchant text is inert.
          this._preview.textContent = words.slice(0, limit).join(' ') + '\u2026';
          this.setExpanded(this._expanded === true);
          this._button.hidden = false;
          this._button.addEventListener('click', this._onToggle);
        } else {
          this._preview.textContent = '';
          this._preview.hidden = true;
          this._full.hidden = false;
          this._button.hidden = true;
          this._button.setAttribute('aria-expanded', 'true');
        }
        window.addEventListener('beforeprint', this._beforePrint);
        window.addEventListener('afterprint', this._afterPrint);
        window.addEventListener('hashchange', this._onHash);
        this.revealHash();
        this.setAttribute('data-description-ready', '');
      } catch (error) {
        // A failure must expose the complete description, never hide it.
        this._full.hidden = false;
        this._preview.hidden = true;
        this._button.hidden = true;
      }
    }

    setExpanded(expanded) {
      this._expanded = expanded;
      this._full.hidden = !expanded;
      this._preview.hidden = expanded;
      this._button.setAttribute('aria-expanded', String(expanded));
      this._button.textContent = expanded ? this._less : this._more;
    }

    toggle() {
      const collapsing = this._expanded;
      const wasAboveViewport = this.getBoundingClientRect().top < 0;
      this.setExpanded(!this._expanded);
      if (collapsing && wasAboveViewport) {
        // Avoid leaving the reader at an unrelated section below a long post.
        // Instant positioning also respects a reduced-motion preference.
        this.scrollIntoView({ block: 'start', behavior: 'instant' });
      }
    }

    revealHash() {
      let id;
      try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
      if (!id) return;
      const target = document.getElementById(id);
      if (!target || !this._full.contains(target)) return;
      if (this._canCollapse) this.setExpanded(true);
      if (this._accordion) this._accordion.open = true;
      // Preserve links to an anchor within the initially hidden description.
      target.scrollIntoView({ block: 'start', behavior: 'instant' });
    }

    beforePrint() {
      if (this._printState) return;
      this._printState = { expanded: this._expanded, open: this._accordion?.open };
      if (this._canCollapse) this.setExpanded(true);
      if (this._accordion) this._accordion.open = true;
    }

    afterPrint() {
      if (!this._printState) return;
      if (this._canCollapse) this.setExpanded(this._printState.expanded === true);
      if (this._accordion) this._accordion.open = this._printState.open;
      this._printState = null;
    }
  }
  customElements.define('wgp-product-description', WGPProductDescription);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sidebar-slideshow"] && !Shopify.designMode) return;
  try {
    /* Isolated docked landscape-ad carousel. It observes only the drawer's open state;
   it does not replace the drawer controller, links, or drill-down animations. */
(() => {
  'use strict';
  const TAG = 'wgp-sidebar-slideshow';
  if (customElements.get(TAG)) return;
  class SidebarSlideshow extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected && !this.initialized) this.initialize(); });
    }
    initialize() {
      this.dialog = this.closest('dialog');
      this.frame = this.querySelector('[data-sidebar-frame]');
      this.slides = [...this.querySelectorAll('[data-sidebar-slide]')];
      if (!this.dialog || !this.frame || !this.slides.length) return;
      this.initialized = true;
      this.abort = new AbortController();
      this.counter = this.querySelector('[data-sidebar-counter]');
      this.rotation = this.querySelector('[data-sidebar-rotation]');
      this.status = this.querySelector('[data-sidebar-status]');
      this.index = Math.max(0, this.slides.findIndex(slide => slide.dataset.current === 'true'));
      this.interval = Math.min(20000, Math.max(3000, Number(this.dataset.interval) || 6000));
      this.duration = Math.min(1200, Math.max(300, Number(this.dataset.duration) || 800));
      this.auto = this.dataset.autoplay === 'true' && this.slides.length > 1;
      this.changeOnOpen = this.dataset.changeOnOpen === 'true';
      this.editor = this.dataset.editor === 'true' || Boolean(window.Shopify?.designMode);
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.editorPlaying = false;
      this.hovered = false;
      this.allowHover = false;
      this.wasOpen = false;
      this.busy = false;
      this.inView = !('IntersectionObserver' in window);
      this.revision = (this.revision || 0) + 1;
      this.animations = [];
      this.timer = null;
      this.finishTimer = null;
      this.prepareCancel = null;
      this.pointerIntent = null;
      this.touch = null;
      this.suppressClickUntil = 0;
      this.lastShownId = null;
      this.storageKey = `wgp-sidebar-slide:${this.dataset.sectionId || 'header'}`;
      this.reflect();
      this.openObserver = new MutationObserver(() => this.syncOpen());
      this.openObserver.observe(this.dialog, { attributes: true, attributeFilter: ['open'] });
      this.listen(this.dialog, 'close', () => this.syncOpen());
      this.listen(document, 'visibilitychange', () => { this.cancel(); this.syncPlayback(); });
      this.listen(window, 'pagehide', () => this.cancel());
      this.listen(window, 'pageshow', () => { this.syncOpen(); this.fitDock(); this.syncPlayback(); });
      this.listen(window, 'resize', () => this.fitDock());
      if ('ResizeObserver' in window) {
        this.sizeObserver = new ResizeObserver(() => this.fitDock());
        [this.dialog, this.dialog.querySelector('.drawer__head'), this.dialog.querySelector('.menu-dialog__footer'), this.querySelector('.wgp-sidebar-show__heading')].filter(Boolean).forEach(node => this.sizeObserver.observe(node));
      }
      this.listen(this.motion, 'change', () => {
        if (this.motion.matches) this.paused = true;
        this.cancel(); this.syncPlayback();
      });
      this.listen(this, 'pointerenter', event => {
        if (event.pointerType === 'mouse' || event.pointerType === 'pen') { this.hovered = true; this.syncPlayback(); }
      });
      this.listen(this, 'pointerleave', () => { this.hovered = false; this.allowHover = false; this.syncPlayback(); });
      this.listen(this, 'focusin', () => { this.paused = true; this.allowHover = false; this.syncPlayback(); });
      this.listen(this, 'pointerdown', event => {
        if (event.target.closest('[data-sidebar-rotation]')) this.pointerIntent = this.auto && !this.paused && (!this.editor || this.editorPlaying);
        if (event.pointerType === 'touch' && this.frame.contains(event.target) && !event.target.closest('button')) this.touch = { x: event.clientX, y: event.clientY, at: performance.now(), id: event.pointerId };
      });
      this.listen(this, 'pointercancel', () => { this.touch = null; this.pointerIntent = null; });
      this.listen(this, 'pointerup', event => {
        const start = this.touch; this.touch = null;
        if (!start || start.id !== event.pointerId) return;
        const dx = event.clientX - start.x, dy = event.clientY - start.y;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5 && performance.now() - start.at < 900) {
          this.suppressClickUntil = performance.now() + 500;
          this.paused = true;
          this.go(this.nextIndex(dx < 0 ? 1 : -1), { announce: true });
        }
      });
      this.listen(this, 'click', event => {
        if (event.target.closest('a') && performance.now() < this.suppressClickUntil) { event.preventDefault(); return; }
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.matches('[data-sidebar-rotation]')) {
          this.paused = this.pointerIntent === null ? !this.paused : this.pointerIntent;
          this.pointerIntent = null;
          if (this.editor) this.editorPlaying = !this.paused;
          this.allowHover = !this.paused;
          this.syncPlayback();
        } else if (button.matches('[data-sidebar-step]')) {
          this.paused = true;
          this.go(this.nextIndex(Number(button.dataset.sidebarStep)), { announce: true });
        }
      });
      this.listen(this, 'keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); event.stopPropagation();
        this.paused = true;
        this.go(this.nextIndex(event.key === 'ArrowRight' ? 1 : -1), { announce: true });
      });
      if ('IntersectionObserver' in window) {
        this.viewportObserver = new IntersectionObserver(entries => {
          this.inView = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .15);
          this.syncPlayback();
        }, { root: this.dialog, threshold: [0, .15] });
        this.viewportObserver.observe(this.frame);
      }
      if (this.editor) {
        this.listen(document, 'shopify:block:select', event => {
          const id = event.detail?.blockId || event.target.closest?.('[data-block-id]')?.dataset.blockId;
          const index = this.slides.findIndex(slide => slide.dataset.blockId === id);
          if (index < 0) return;
          this.editorPlaying = false;
          this.paused = true;
          if (!this.dialog.open) {
            if (window.Portal?.openDialog) window.Portal.openDialog(this.dialog, document.activeElement);
            else if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
          }
          this.syncOpen();
          this.go(index, { immediate: true });
          this.fitDock();
        });
      }
      this.dataset.ready = 'true';
      this.syncOpen();
    }
    listen(target, type, listener) { target.addEventListener(type, listener, { signal: this.abort.signal }); }
    fitDock() {
      if (!this.dialog?.open) return;
      const dock = this.closest('.wgp-sidebar-ad-dock');
      const nav = this.dialog.querySelector('.menu-dialog__body');
      if (!dock || !nav) return;
      const height = node => node ? node.getBoundingClientRect().height : 0;
      const head = this.dialog.querySelector('.drawer__head');
      const footer = this.dialog.querySelector('.menu-dialog__footer');
      const heading = this.querySelector('.wgp-sidebar-show__heading');
      const dockStyle = getComputedStyle(dock);
      const headingStyle = heading ? getComputedStyle(heading) : null;
      const numeric = value => parseFloat(value) || 0;
      const reservedMenu = Math.max(84, numeric(getComputedStyle(nav).minHeight));
      const extras = numeric(dockStyle.paddingTop) + numeric(dockStyle.paddingBottom) + height(heading) + numeric(headingStyle?.marginTop) + numeric(headingStyle?.marginBottom);
      const available = Math.max(0, this.dialog.clientHeight - height(head) - height(footer) - reservedMenu - extras);
      const width = `${Math.floor(available * 4 / 3)}px`;
      if (this.style.getPropertyValue('--wgp-sidebar-room-width') !== width) this.style.setProperty('--wgp-sidebar-room-width', width);
    }
    nextIndex(step = 1, from = this.index) {
      if (this.slides.length < 2) return 0;
      if (this.dataset.order === 'random' && step > 0) {
        const choices = this.slides.map((_, index) => index).filter(index => index !== from);
        return choices[Math.floor(Math.random() * choices.length)];
      }
      return (from + step + this.slides.length) % this.slides.length;
    }
    remember() {
      this.lastShownId = this.slides[this.index]?.dataset.blockId;
      if (this.editor || !this.changeOnOpen || !this.lastShownId) return;
      try { sessionStorage.setItem(this.storageKey, this.lastShownId); } catch (_) { /* Optional, tab-scoped memory only. */ }
    }
    syncOpen() {
      if (!this.initialized) return;
      const open = this.dialog.open;
      if (open) this.fitDock();
      if (open === this.wasOpen) { this.syncPlayback(); return; }
      this.wasOpen = open;
      this.cancel();
      if (!open) { this.hovered = false; this.allowHover = false; this.syncPlayback(); return; }
      let next = this.index;
      if (this.changeOnOpen && !this.editor && this.slides.length > 1) {
        let previous = this.lastShownId;
        if (!previous) { try { previous = sessionStorage.getItem(this.storageKey); } catch (_) {} }
        const found = this.slides.findIndex(slide => slide.dataset.blockId === previous);
        if (found >= 0) next = this.nextIndex(1, found);
        else next = this.dataset.order === 'random' ? Math.floor(Math.random() * this.slides.length) : 0;
      }
      this.go(next, { entry: true });
    }
    get canRotate() {
      return this.initialized && this.isConnected && this.dialog?.open && this.auto && (!this.editor || this.editorPlaying) && !this.paused && !this.busy && !document.hidden && this.inView && (!this.hovered || this.allowHover);
    }
    syncPlayback() {
      clearTimeout(this.timer); this.timer = null;
      if (!this.initialized) return;
      const requested = this.auto && !this.paused && (!this.editor || this.editorPlaying);
      this.dataset.playback = !this.auto ? 'manual' : !requested ? 'paused' : this.canRotate ? 'playing' : 'suspended';
      if (this.rotation) {
        this.rotation.hidden = !this.auto;
        this.rotation.setAttribute('aria-label', requested ? 'Pause sidebar slideshow' : 'Play sidebar slideshow');
        this.rotation.querySelector('[data-sidebar-pause]').hidden = !requested;
        this.rotation.querySelector('[data-sidebar-play]').hidden = requested;
      }
      if (this.canRotate) this.timer = setTimeout(() => { this.timer = null; if (this.canRotate) this.go(this.nextIndex()); }, this.interval);
    }
    reflect() {
      this.slides.forEach((slide, index) => {
        const current = index === this.index;
        slide.dataset.current = String(current);
        slide.removeAttribute('data-leaving');
        slide.setAttribute('aria-hidden', String(!current));
        slide.inert = !current;
        slide.querySelectorAll('a').forEach(link => { if (current) link.removeAttribute('tabindex'); else link.tabIndex = -1; });
      });
      if (this.counter) this.counter.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    prepare(slide) {
      const image = slide?.querySelector('img');
      if (!image) return Promise.resolve();
      image.loading = 'eager';
      // Bounded decoding/loading. Slow or broken images never disable controls.
      return new Promise(resolve => {
        let done = false;
        const finish = () => {
          if (done) return; done = true;
          clearTimeout(timeout);
          image.removeEventListener('load', loaded); image.removeEventListener('error', finish);
          if (this.prepareCancel === finish) this.prepareCancel = null;
          resolve();
        };
        const loaded = () => {
          try { if (image.decode) image.decode().then(finish, finish); else finish(); } catch (_) { finish(); }
        };
        const timeout = setTimeout(finish, 1600);
        this.prepareCancel = finish;
        if (image.complete) loaded();
        else { image.addEventListener('load', loaded, { once: true }); image.addEventListener('error', finish, { once: true }); }
      });
    }
    cancel() {
      this.revision += 1;
      clearTimeout(this.timer); this.timer = null;
      clearTimeout(this.finishTimer); this.finishTimer = null;
      this.prepareCancel?.();
      for (const animation of this.animations || []) { try { animation.cancel(); } catch (_) {} }
      this.animations = [];
      this.busy = false;
      this.removeAttribute('data-transitioning');
      if (this.slides?.length) this.reflect();
    }
    finish(revision) {
      if (!this.initialized || revision !== this.revision || !this.busy) return;
      clearTimeout(this.finishTimer); this.finishTimer = null;
      for (const animation of this.animations) { try { animation.cancel(); } catch (_) {} }
      this.animations = [];
      this.busy = false;
      this.removeAttribute('data-transitioning');
      this.reflect(); this.syncPlayback();
    }
    async go(requested, { immediate = false, entry = false, announce = false } = {}) {
      if (!this.initialized || !this.dialog.open || !this.slides.length) return;
      this.cancel();
      const next = (requested % this.slides.length + this.slides.length) % this.slides.length;
      const outgoing = this.slides[this.index], incoming = this.slides[next];
      if (next === this.index && !entry) { this.syncPlayback(); return; }
      const revision = this.revision;
      this.busy = true; this.syncPlayback();
      incoming.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
      if (!immediate && !entry) await this.prepare(incoming);
      if (!this.isConnected || !this.dialog.open || revision !== this.revision) return;
      if (outgoing !== incoming && outgoing.contains(document.activeElement)) this.querySelector('[data-sidebar-step="1"]')?.focus({ preventScroll: true });
      this.index = next; this.reflect(); this.remember();
      if (announce && this.status) {
        const title = incoming.querySelector('[data-sidebar-heading]')?.textContent?.trim();
        this.status.textContent = `Promotion ${this.index + 1} of ${this.slides.length}${title ? ': ' + title : ''}`;
      }
      if (immediate || this.motion.matches || this.editor || typeof incoming.animate !== 'function') { this.finish(revision); return; }
      this.dataset.transitioning = 'true';
      const drift = Math.min(28, Math.max(16, this.frame.clientWidth * .065));
      const options = { duration: this.duration, easing: 'cubic-bezier(.2,.6,.2,1)', fill: 'both' };
      // Start the fallback before animations: a suspended/failed effect cannot
      // retain ownership of the selected image's opacity after the deadline.
      this.finishTimer = setTimeout(() => this.finish(revision), this.duration + 250);
      try {
        if (!entry && outgoing !== incoming) {
          outgoing.setAttribute('data-leaving', '');
          this.animations.push(outgoing.animate([{ opacity: 1, transform: 'translateX(0)' }, { opacity: 0, transform: `translateX(-${drift}px)` }], options));
        }
        this.animations.push(incoming.animate([{ opacity: 0, transform: `translateX(-${drift}px)` }, { opacity: 1, transform: 'translateX(0)' }], options));
        Promise.allSettled(this.animations.map(animation => animation.finished)).then(() => this.finish(revision));
      } catch (_) { this.finish(revision); }
    }
    disconnectedCallback() {
      if (!this.initialized) return;
      this.cancel(); this.abort.abort(); this.openObserver?.disconnect(); this.viewportObserver?.disconnect(); this.sizeObserver?.disconnect();
      this.initialized = false; this.removeAttribute('data-ready');
    }
  }
  customElements.define(TAG, SidebarSlideshow);
})();
  } catch(e) { console.error(e); }
})();

})();
